module.exports = "https://cdn.thelire.com/ins/resource/lh_store_vip_speed.d3b2e746fcfba8c9e0b524a4f0f5a564.png";